import interrupt from "../interrupt";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-transition/src/selection/interrupt.js
// module id = ../../../../d3-transition/src/selection/interrupt.js
// module chunks = 4